// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-4ad24a60] .el-form-item__label {\n  font-size: 12px;\n}\n.image-container[data-v-4ad24a60] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.image-container .image[data-v-4ad24a60] {\n  width: 120px;\n  height: 120px;\n  margin: 0 20px 20px 0;\n}\n", ""]);
// Exports
module.exports = exports;
